import { useOne } from '@refinedev/core';
import { parseTimeToSeconds } from 'src/meetings/detail/tabs/transcript/timeUtils';
import type { Transcript } from 'src/meetings/detail/tabs/transcript/types';

type UseTranscriptResult = {
  transcript: Transcript | undefined;
  isLoading: boolean;
  isError: boolean;
  error: unknown;
  refetch: () => void;
};

type Props = {
  eventId: string;
  enabled?: boolean;
};

export const useTranscript = ({ eventId, enabled = true }: Props): UseTranscriptResult => {
  const { data, isLoading, isError, error, refetch } = useOne<Transcript>({
    resource: `calendar-events/${eventId}/transcript`,
    id: '',
    queryOptions: {
      enabled,
      select: response => {
        if (!response.data?.segments) {
          return response;
        }

        return {
          ...response,
          data: {
            ...response.data,
            segments: [...response.data.segments].sort(
              (a, b) => parseTimeToSeconds(a.startTime) - parseTimeToSeconds(b.startTime),
            ),
          },
        };
      },
    },
  });

  return {
    transcript: data?.data,
    isLoading,
    isError,
    error,
    refetch,
  };
};
